export const topBarHeight = 64;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
// export const WebUrl = "http://127.0.0.1:8000/";
// export const WebUrl = "http://103.71.99.180:8000/";
// export const WebUrl = "http://103.74.54.133:8000/";
// export const WebUrl = "https://www.incometaxlibrary.in/";
export const WebUrl = "https://incometaxlibrary.com/";

export const BASE_URL = '/dashboard';
export const BaseTitle = 'Income Tax Library';

export const CONFIG = {
  layout: 'vertical',
  collapseMenu: false,
  layoutType: 'menu-dark'

};

export const FAVOUR_OPTIONS = [
  { value: "Assessee", label: "Assessee" },
  { value: "Revenue", label: "Revenue" },
  { value: "Partly", label: "Partly" },
  { value: "Matter Remanded", label: "Matter Remanded" },
];

export const JOURNAL_WISE_OPTIONS = [
  { value: "ITR", label: "ITR" },
  { value: "CTR", label: "CTR" },
  { value: "DTR", label: "DTR" },
  { value: "ITD", label: "ITD" },
  { value: "TTJ", label: "TTJ" },
  { value: "SOT", label: "SOT" },
  { value: "ITL", label: "ITL" },
  { value: "ITR(Trib)", label: "ITR(Trib)" },
  { value: "TAXMAN", label: "TAXMAN" },
];

export const GST_JOURNAL_WISE_OPTIONS = [
  { value: "STR", label: "STR" },
  { value: "STT", label: "STT" },
  { value: "VST", label: "VST" },
  { value: "ITL", label: "ITL" },
];

export const CL_JOURNAL_WISE_OPTIONS = [
  { value: "CC", label: "CC" },
  { value: "CLA", label: "CLA" },
  { value: "ITL", label: "ITL" },
];

export const COURT_TYPE_OPTIONS = [
  { value: "AAR", label: "AAR" },
  { value: "ALL-ITAT", label: "ALL-ITAT" },
  { value: "ALL-HC", label: "ALL-HC" },
  { value: "SC", label: "SC" },
];

export const STATES = [
  { label: "Andaman and Nicobar Islands", value: "Andaman and Nicobar Islands" },
  { label: "Andhra Pradesh", value: "Andhra Pradesh" },
  { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
  { label: "Assam", value: "Assam" },
  { label: "Bihar", value: "Bihar" },
  { label: "Chandigarh", value: "Chandigarh" },
  { label: "Chhattisgarh", value: "Chhattisgarh" },
  { label: "Dadra and Nagar Haveli and Daman and Diu", value: "Dadra and Nagar Haveli and Daman and Diu" },
  { label: "Goa", value: "Goa" },
  { label: "Gujarat", value: "Gujarat" },
  { label: "Haryana", value: "Haryana" },
  { label: "Himachal Pradesh", value: "Himachal Pradesh" },
  { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
  { label: "Jharkhand", value: "Jharkhand" },
  { label: "Karnataka", value: "Karnataka" },
  { label: "Kerala", value: "Kerala" },
  { label: "Ladakh", value: "Ladakh" },
  { label: "Lakshadweep", value: "Lakshadweep" },
  { label: "Madhya Pradesh", value: "Madhya Pradesh" },
  { label: "Maharashtra", value: "Maharashtra" },
  { label: "Manipur", value: "Manipur" },
  { label: "Meghalaya", value: "Meghalaya" },
  { label: "Mizoram", value: "Mizoram" },
  { label: "Nagaland", value: "Nagaland" },
  { label: "New Delhi", value: "New Delhi" },
  { label: "Odisha", value: "Odisha" },
  { label: "Puducherry", value: "Puducherry" },
  { label: "Punjab", value: "Punjab" },
  { label: "Rajasthan", value: "Rajasthan" },
  { label: "Sikkim", value: "Sikkim" },
  { label: "Tamil Nadu", value: "Tamil Nadu" },
  { label: "Telangana", value: "Telangana" },
  { label: "Tripura", value: "Tripura" },
  { label: "Uttar Pradesh", value: "Uttar Pradesh" },
  { label: "Uttarakhand", value: "Uttarakhand" },
  { label: "West Bengal", value: "West Bengal" },
];